/* eslint-disable camelcase */
export default class WorkOrder {
  order_no = '';
  part_number = '';
  is_programming_required = '';
  qty = 0;
  balance = 0;
  reference_no = '';
  due_date = '';
  description = '';
  comments = '';
}



// WEBPACK FOOTER //
// ./resources/assets/js/_shared/models/WorkOrder.js